/* Soulshine — Auto-UF pelo CEP + reescreve resultados de frete com PRAZO */
(function () {
  function ufFromCep(cep) {
    var digits = String(cep || '').replace(/\D/g, '');
    if (digits.length < 5) return '';
    var n = parseInt(digits.slice(0, 5), 10);
    if (isNaN(n)) return '';
    if (n <= 19999) return 'SP';
    if (n <= 28999) return 'RJ';
    if (n <= 29999) return 'ES';
    if (n <= 39999) return 'MG';
    if (n <= 48999) return 'BA';
    if (n <= 49999) return 'SE';
    if (n <= 56999) return 'PE';
    if (n <= 57999) return 'AL';
    if (n <= 58999) return 'PB';
    if (n <= 59999) return 'RN';
    if (n <= 63999) return 'CE';
    if (n <= 64999) return 'PI';
    if (n <= 65999) return 'MA';
    if (n <= 68899) return 'PA';
    if (n <= 68999) return 'AP';
    if (n <= 69299) return 'AM';
    if (n <= 69399) return 'RR';
    if (n <= 69899) return 'AM';
    if (n <= 69999) return 'AC';
    if (n <= 72799) return 'DF';
    if (n <= 72999) return 'GO';
    if (n <= 73699) return 'DF';
    if (n <= 76799) return 'GO';
    if (n <= 76999) return 'RO';
    if (n <= 77999) return 'TO';
    if (n <= 78899) return 'MT';
    if (n <= 79999) return 'MS';
    if (n <= 87999) return 'PR';
    if (n <= 89999) return 'SC';
    return 'RS';
  }

  function formatPrice(value) {
    var n = parseFloat(value);
    if (isNaN(n) || n === 0) return 'Grátis';
    return 'R$ ' + n.toFixed(2).replace('.', ',');
  }

  function formatDelivery(rate) {
    if (rate.delivery_days && rate.delivery_days.length) {
      var dd = rate.delivery_days;
      if (dd.length === 1) return dd[0] + ' dias úteis';
      var min = dd[0], max = dd[dd.length - 1];
      if (min === max) return min + ' dias úteis';
      return min + '–' + max + ' dias úteis';
    }
    if (rate.delivery_range && rate.delivery_range.length === 2) {
      var now = new Date(); now.setHours(0, 0, 0, 0);
      function diffDays(s) {
        var d = new Date(s);
        if (isNaN(d.getTime())) return null;
        return Math.ceil((d - now) / 86400000);
      }
      var min = diffDays(rate.delivery_range[0]);
      var max = diffDays(rate.delivery_range[1]);
      if (min && max) {
        if (min === max) return min + ' dias úteis';
        return min + '–' + max + ' dias úteis';
      }
    }
    return '';
  }

  function buildHtml(rates) {
    if (!rates || rates.length === 0) {
      return '<p style="color:#be123c; padding:8px 0;">Nenhuma opção de frete disponível para este CEP.</p>';
    }
    return rates.map(function (rate) {
      var name = rate.presentment_name || rate.name || 'Frete';
      var price = formatPrice(rate.price);
      var delivery = formatDelivery(rate);
      return (
        '<div style="display:flex; justify-content:space-between; align-items:center; padding:10px 0; border-bottom:1px solid rgba(0,0,0,0.08);">' +
        '<div style="flex:1; min-width:0;">' +
        '<div style="font-weight:500; font-size:14px;">' + name + '</div>' +
        (delivery ? '<div style="color:#666; font-size:12px; margin-top:2px;">' + delivery + '</div>' : '') +
        '</div>' +
        '<div style="font-weight:600; font-size:14px; margin-left:12px; white-space:nowrap;">' + price + '</div>' +
        '</div>'
      );
    }).join('');
  }

  function renderEverywhere(rates) {
    var html = buildHtml(rates);
    /* Renderiza em qualquer container conhecido do calculador inline */
    var selectors = [
      '.cart-drawer-shipping-results',
      'form[is="shipping-calculator"] .grid.gap-3.text-sm',
      'form[is="shipping-calculator"] > div:last-child'
    ];
    var found = false;
    selectors.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        el.innerHTML = html;
        el.setAttribute('data-cep-fix-rendered', '1');
        found = true;
      });
    });
    return found;
  }

  /* Monkey-patch fetch para capturar a resposta do shipping_rates */
  var origFetch = window.fetch;
  window.fetch = function () {
    var args = arguments;
    var urlArg = args[0];
    var url = typeof urlArg === 'string' ? urlArg : (urlArg && urlArg.url) || '';
    var promise = origFetch.apply(this, args);
    if (url && url.indexOf('shipping_rates.json') !== -1) {
      promise.then(function (r) { return r.clone().json(); })
        .then(function (data) {
          if (data && data.shipping_rates) {
            /* Renderiza algumas vezes para sobrescrever o render do tema */
            setTimeout(function () { renderEverywhere(data.shipping_rates); }, 50);
            setTimeout(function () { renderEverywhere(data.shipping_rates); }, 250);
            setTimeout(function () { renderEverywhere(data.shipping_rates); }, 700);
            setTimeout(function () { renderEverywhere(data.shipping_rates); }, 1500);
          }
        })
        .catch(function () { });
    }
    return promise;
  };

  /* Auto-preenche UF pelo CEP */
  function bindForm(form) {
    if (!form || form.dataset.cepFixApplied) return;
    form.dataset.cepFixApplied = '1';
    var zip = form.querySelector('input[name="address[zip]"]');
    var prov = form.querySelector('input[name="address[province]"]');
    if (!zip) return;
    function update() {
      if (prov) {
        var uf = ufFromCep(zip.value);
        if (uf) prov.value = uf;
      }
    }
    zip.addEventListener('input', update);
    zip.addEventListener('blur', update);
    if (zip.value) update();
  }

  function init() {
    document.querySelectorAll('form[is="shipping-calculator"]').forEach(bindForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  var obs = new MutationObserver(function () {
    document.querySelectorAll('form[is="shipping-calculator"]:not([data-cep-fix-applied])').forEach(bindForm);
  });
  obs.observe(document.body, { childList: true, subtree: true });
})();
